import React from 'react'
import { KaziCard } from './Cards/KaziCard'
import { SavingsOutlined } from '@mui/icons-material'
import { SxProps } from '@mui/material'
interface KaziWalletProps {
    sx?: SxProps
}
export const KaziWallet = (props: KaziWalletProps) => {
/* ******************** Hooks ******************** */
/* ******************** Variables ******************** */
    const card = {
        title: "0 upcoming payments",
        icon: <SavingsOutlined />,
        disabled: true
    }
/* ******************** Functions ******************** */
/* ******************** Effects ******************** */
/* ******************** JSX ******************** */
    return (
        <KaziCard
            title={card.title}
            icon={card.icon}
            sx={props?.sx}
        />
    )
}